import { Box } from '@esgian/esgianui';
import React from 'react';
import Dropdown from './Dropdown';
import PropTypes from 'prop-types';

export const calculationTypeOptions = [
  {
    label: 'Esgian calculation',
    value: 'esgian',
    tooltip:
      'Display the default results based on fuel types and EU Allowance cost assumed by Esgian.'
  },
  {
    label: 'Customised calculation',
    value: 'customised',
    tooltip:
      'Display results corresponding to the modified fuel types and EU Allowance cost which is only visible to the user.'
  }
];

const CalculationTypeDropdown = ({ selectedCalculationType, onSelect, isLoading }) => {
  return (
    <Box width="280px">
      <Dropdown
        options={calculationTypeOptions}
        selectedValue={selectedCalculationType}
        onSelect={onSelect}
        size="small"
        isLoading={isLoading}
      />
    </Box>
  );
};

CalculationTypeDropdown.propTypes = {
  selectedCalculationType: PropTypes.oneOf(calculationTypeOptions.map((o) => o.value)).isRequired,
  onSelect: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};

export default CalculationTypeDropdown;
